module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.projectID == '') ? _c('div', [_c('div', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("common.no_project_loaded")) + ".")])])]) : (!_vm.hasData) ? _c('div', [_c('div', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("common.no_data_loaded")))])])]) : _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('help', {
    attrs: {
      "reflink": "optimizations",
      "label": _vm.$t("optimization.Define optimizations")
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover table-striped",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allActive),
      expression: "allActive"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allActive) ? _vm._i(_vm.allActive, null) > -1 : (_vm.allActive)
    },
    on: {
      "click": function($event) {
        return _vm.modalDeselectAllOptims()
      },
      "change": function($event) {
        var $$a = _vm.allActive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allActive = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allActive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allActive = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("Name")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("Databook")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("Status")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("Actions")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.optimSummaries), function(optimSummary) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (optimSummary.active),
        expression: "optimSummary.active"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(optimSummary.active) ? _vm._i(optimSummary.active, null) > -1 : (optimSummary.active)
      },
      on: {
        "click": function($event) {
          return _vm.uncheckSelectAll()
        },
        "change": function($event) {
          var $$a = optimSummary.active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(optimSummary, "active", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(optimSummary, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(optimSummary, "active", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(optimSummary.name))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(optimSummary.model_name))])]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.statusFormatStr(optimSummary)) + "\n            " + _vm._s(_vm.timeFormatStr(optimSummary)) + "\n          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_c('button', {
      staticClass: "btn __green",
      attrs: {
        "disabled": !_vm.canRunTask(optimSummary)
      },
      on: {
        "click": function($event) {
          return _vm.runOptim(optimSummary, 'full')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("common.Run")))]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      attrs: {
        "disabled": !_vm.canRunTask(optimSummary)
      },
      on: {
        "click": function($event) {
          return _vm.runOptim(optimSummary, 'test')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("common.Test run")))]), _vm._v(" "), _c('button', {
      staticClass: "btn __red",
      attrs: {
        "disabled": !_vm.canCancelTask(optimSummary)
      },
      on: {
        "click": function($event) {
          return _vm.clearTask(optimSummary)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("common.Clear results")))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon",
      attrs: {
        "data-tooltip": _vm.$t("optimization.Edit optimization")
      },
      on: {
        "click": function($event) {
          return _vm.editOptimModal(optimSummary)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon",
      attrs: {
        "data-tooltip": _vm.$t("optimization.Copy optimization")
      },
      on: {
        "click": function($event) {
          return _vm.copyOptim(optimSummary)
        }
      }
    }, [_c('i', {
      staticClass: "ti-files"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon",
      attrs: {
        "data-tooltip": _vm.$t("optimization.Delete optimization")
      },
      on: {
        "click": function($event) {
          return _vm.deleteOptim(optimSummary)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    })])])])
  }), 0)]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculateCostEff),
      expression: "calculateCostEff"
    }],
    attrs: {
      "type": "checkbox",
      "id": "costeff_checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.calculateCostEff) ? _vm._i(_vm.calculateCostEff, null) > -1 : (_vm.calculateCostEff)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.calculateCostEff,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.calculateCostEff = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.calculateCostEff = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.calculateCostEff = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "costeff_checkbox"
    }
  }, [_vm._v(_vm._s(_vm.$t("optimization.perform_costeff")))])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn __green",
    attrs: {
      "disabled": !_vm.optimsLoaded || !_vm.anySelected
    },
    on: {
      "click": function($event) {
        return _vm.plotOptims(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("optimization.Plot optimizations")))]), _vm._v(" "), _c('button', {
    staticClass: "btn __green",
    attrs: {
      "disabled": !_vm.optimsLoaded || _vm.calculateCostEff || !_vm.anySelected
    },
    on: {
      "click": function($event) {
        return _vm.UncertScensModal(10)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("optimization.Plot optimizations with uncertainty")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": !_vm.optimsLoaded
    },
    on: {
      "click": function($event) {
        return _vm.addOptimModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("optimization.Add optimization")))])])], 1)]), _vm._v(" "), (_vm.hasGraphs) ? _c('div', {
    staticClass: "card full-width-card"
  }, [_c('div', {
    staticClass: "calib-title"
  }, [_c('help', {
    attrs: {
      "reflink": "results-plots",
      "label": "Results"
    }
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-icon",
    attrs: {
      "data-tooltip": _vm.$t("common.Zoom out")
    },
    on: {
      "click": function($event) {
        return _vm.scaleFigs(0.9)
      }
    }
  }, [_vm._v("–")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon",
    attrs: {
      "data-tooltip": _vm.$t("common.Reset zoom")
    },
    on: {
      "click": function($event) {
        return _vm.scaleFigs(1.0)
      }
    }
  }, [_c('i', {
    staticClass: "ti-zoom-in"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon",
    attrs: {
      "data-tooltip": _vm.$t("common.Zoom in")
    },
    on: {
      "click": function($event) {
        return _vm.scaleFigs(1.1)
      }
    }
  }, [_vm._v("+")]), _vm._v("\n           \n        "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.exportGraphs(_vm.projectID, 'opts')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.Export plots")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.exportResults(_vm.projectID, 'opts')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.Export data")))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "calib-main",
    class: {
      'calib-main--full': true
    }
  }, [_c('div', {
    staticClass: "calib-graphs"
  }, [_c('div', {
    staticClass: "other-graphs"
  }, _vm._l((_vm.placeholders), function(index) {
    return _c('div', {
      staticClass: "calib-graph",
      attrs: {
        "id": 'fig' + index
      }
    })
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.hasTable) ? _c('div', [_c('help', {
    attrs: {
      "reflink": "cost-effectiveness",
      "label": "Program cost-effectiveness"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calib-graphs",
    staticStyle: {
      "display": "inline-block",
      "text-align": "right",
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-hover table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("optimization.Optimization/program")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("Outcomes")))]), _vm._v(" "), _vm._l((_vm.table[0].length - 3), function(i) {
    return _c('th')
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.table), function(rowdata) {
    return _c('tr', _vm._l(((rowdata.length - 1)), function(i) {
      return _c('td', [(rowdata[0] === 'header') ? _c('span', {
        staticStyle: {
          "font-size": "15px",
          "font-weight": "bold"
        }
      }, [_vm._v(_vm._s(rowdata[i]))]) : (rowdata[0] === 'keys' && i == 1) ? _c('span', {
        staticStyle: {
          "font-size": "12px",
          "font-style": "italic"
        }
      }, [_vm._v(_vm._s(rowdata[i]))]) : (rowdata[0] === 'keys' && i != 1) ? _c('span', {
        staticStyle: {
          "font-size": "12px",
          "font-weight": "bold"
        }
      }, [_vm._v(_vm._s(rowdata[i]))]) : (rowdata[0] === 'entry' && i == 1) ? _c('span', {
        staticStyle: {
          "font-size": "12px",
          "font-weight": "bold"
        }
      }, [_vm._v(_vm._s(rowdata[i]))]) : (rowdata[0] === 'entry' && i != 1) ? _c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("                 " + _vm._s(rowdata[i]))]) : _c('span', [_c('div', {
        staticStyle: {
          "min-height": "30px"
        }
      })])])
    }), 0)
  }), 0)])])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "add-optim",
      "height": "auto",
      "scrollable": true,
      "classes": ['v--modal', 'vue-dialog'],
      "pivot-y": 0.3,
      "adaptive": true,
      "clickToClose": false
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [(_vm.addEditModal.mode == 'add') ? _c('div', {
    staticClass: "dialog-c-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("optimization.Add optimization")) + "\n      ")]) : _c('div', {
    staticClass: "dialog-c-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("optimization.Edit optimization")) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-c-text",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t("optimization.Optimization name")))]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.optimSummary.name),
      expression: "addEditModal.optimSummary.name"
    }],
    staticClass: "txbox",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.addEditModal.optimSummary.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addEditModal.optimSummary, "name", $event.target.value)
      }
    }
  }), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("Databook")))]), _c('br'), _vm._v(" "), _c('tr', [_c('th', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.optimSummary.model_name),
      expression: "addEditModal.optimSummary.model_name"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.addEditModal.optimSummary, "model_name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modalSwitchDataset]
    }
  }, _vm._l((_vm.datasetOptions), function(dataset) {
    return _c('option', [_vm._v("\n              " + _vm._s(dataset) + "\n            ")])
  }), 0), _c('br'), _c('br')]), _vm._v("      \n          "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.optimSummary.balanced_optimization),
      expression: "addEditModal.optimSummary.balanced_optimization"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.addEditModal.optimSummary.balanced_optimization) ? _vm._i(_vm.addEditModal.optimSummary.balanced_optimization, null) > -1 : (_vm.addEditModal.optimSummary.balanced_optimization)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.addEditModal.optimSummary.balanced_optimization,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.addEditModal.optimSummary, "balanced_optimization", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.addEditModal.optimSummary, "balanced_optimization", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.addEditModal.optimSummary, "balanced_optimization", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t("optimization.Run balanced optimization?")) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "scrolltable",
    staticStyle: {
      "max-height": "30vh"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("optimization.Optimization objective")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("optimization.Weight")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.addEditModal.optimSummary.weightslist), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(item.label) + "   \n              ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.weight),
        expression: "item.weight"
      }],
      staticClass: "txbox",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.weight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "weight", $event.target.value)
        }
      }
    }), _c('br')])])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("optimization.Budget multipliers")))]), _vm._v(" (1 = " + _vm._s(_vm.$t("optimization.current budget")) + ")"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.optimSummary.mults),
      expression: "addEditModal.optimSummary.mults"
    }],
    staticClass: "txbox",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.addEditModal.optimSummary.mults)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addEditModal.optimSummary, "mults", $event.target.value)
      }
    }
  }), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("optimization.Existing spending")))]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.optimSummary.fix_curr),
      expression: "addEditModal.optimSummary.fix_curr"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.addEditModal.optimSummary.fix_curr, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.addEditModal.optimSummary, "fix_curr", false)
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t("common.Can be reallocated"))), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.optimSummary.fix_curr),
      expression: "addEditModal.optimSummary.fix_curr"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.addEditModal.optimSummary.fix_curr, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.addEditModal.optimSummary, "fix_curr", true)
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t("common.Cannot be reallocated"))), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("optimization.Growth type")))]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.optimSummary.growth),
      expression: "addEditModal.optimSummary.growth"
    }],
    attrs: {
      "type": "radio",
      "value": "fixed budget"
    },
    domProps: {
      "checked": _vm._q(_vm.addEditModal.optimSummary.growth, "fixed budget")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.addEditModal.optimSummary, "growth", "fixed budget")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t("optimization.Fixed budget"))), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.optimSummary.growth),
      expression: "addEditModal.optimSummary.growth"
    }],
    attrs: {
      "type": "radio",
      "value": "fixed coverage"
    },
    domProps: {
      "checked": _vm._q(_vm.addEditModal.optimSummary.growth, "fixed coverage")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.addEditModal.optimSummary, "growth", "fixed coverage")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t("optimization.Fixed coverage"))), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("optimization.Additional funds to allocate")))]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.optimSummary.add_funds),
      expression: "addEditModal.optimSummary.add_funds"
    }],
    staticClass: "txbox",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.addEditModal.optimSummary.add_funds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addEditModal.optimSummary, "add_funds", $event.target.value)
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "scrolltable",
    staticStyle: {
      "max-height": "30vh"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("common.Program name")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t("Include")) + "?")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.addEditModal.optimSummary.programs), function(program) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(program.name) + "\n              ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (program.included),
        expression: "program.included"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(program.included) ? _vm._i(program.included, null) > -1 : (program.included)
      },
      on: {
        "change": function($event) {
          var $$a = program.included,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(program, "included", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(program, "included", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(program, "included", $$c)
          }
        }
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "data-tooltip": _vm.$t("optimization.Deselect all interventions")
    },
    on: {
      "click": function($event) {
        return _vm.modalDeselectAllProgs()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("Deselect all")))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn __green",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.modalSave()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("Save")) + "\n        ")]), _vm._v("\n           \n        "), _c('button', {
    staticClass: "btn __red",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('add-optim')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("Cancel")) + "\n        ")])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "uncert-nruns",
      "height": "auto",
      "classes": ['v--modal', 'vue-dialog'],
      "width": 400,
      "pivot-y": 0.3,
      "adaptive": true,
      "clickToClose": false
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-c-title"
  }, [_vm._v("\n        Input uncertainty runs\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-c-text"
  }, [_vm._v("\n        Number of runs:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalUncertRuns),
      expression: "modalUncertRuns"
    }],
    staticClass: "txbox",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.modalUncertRuns)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.modalUncertRuns = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('button', {
    staticClass: "btn __green",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        _vm.plotOptims(_vm.modalUncertRuns) | _vm.$modal.hide('uncert-nruns')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("optimization.Plot optimizations")) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn __red",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('uncert-nruns')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("Cancel")) + "\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41ab7426","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/OptimizationsPage.vue
// module id = 374
// module chunks = 1